// extracted by mini-css-extract-plugin
export default {"formControl":"Form_formControl__8qInD","formPenaltyControl":"Form_formPenaltyControl__QGoir"};